const LAUNCH_MAIL_SEARCH = 'LaunchMailSearch';
const SEARCH_SUBMIT = 'SearchSubmit';
const SEARCH_RESULTS_RENDERED = 'SearchResultsRendered';
const SEARCH_NO_RESULTS_RENDERED = 'SearchNoResultsRendered';
const EXIT_SEARCH = 'SearchExit';
const SEARCH_RESULTS_ERROR = 'SearchResultsError';

export {
    LAUNCH_MAIL_SEARCH,
    SEARCH_NO_RESULTS_RENDERED,
    SEARCH_RESULTS_RENDERED,
    EXIT_SEARCH,
    SEARCH_RESULTS_ERROR,
    SEARCH_SUBMIT,
};
